import { makeStyles } from "@material-ui/styles";

export const styleCertificate = makeStyles((theme) => ({
  column: {
    flexBasis: "39.6%",
    marginRight: 10,
  },
  heading: {
    fontSize: theme.typography.pxToRem(12),
    wordBreak: "normal",
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.secondary,
    wordBreak: "normal",
  },
  columnEvent: {
    flexBasis: "33.33%",
    display: "flex",
    alignItems: "center",
  },
  details: {
    width: "100%",
  },
  iconEvent: {
    color: "#666666",
    cursor: "pointer",
    height: 18,
    width: 18,
  },
  columnTwo: {
    flexBasis: "18%",
    marginRight: 10,
    marginBottom: 10,
  },
  menuItem: {
    "&:hover": {
      borderLeft: "4px solid #098B8B",
    },
  },
  contModalDownload: {
    position: "absolute",
    width: "70%",
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.24)",
    outline: "none",
    borderRadius: 8,
    padding: theme.spacing(1, 1, 1),
  },
  bodyModal: {
    width: "100%",
    minHeight: "300px !important",
    maxHeight: 500,
  },
  contAccordion: {
    width: "100%",
    marginTop: "20px !important",
  },
  inputDisabled: {
    backgroundColor: "#eeeeee",
    boxSizing: "border-box",
    borderRadius: "8px",
    height: 40,
    fontSize: "14px",
    [`& fieldset`]: {
      borderRadius: 8,
      fontSize: 14,
    },
  },
  buttonContinue: {
    color: "#ffffff",
    background: "#7EBDCE",
    "&:hover": { color: "white", background: "#099F9F" },
  },
  contBtnSubmit: {
    width: "100%",
    textAlign: "center",
    marginTop: 20,
  },
  paperdos: {
    width: "100%",
    height: 220,
    borderRadius: 5,
  },
  scrollBars: {
    width: "100%",
    height: 200,
    backgroundColor: "#ffffff",
    position: "sticky",
  },
  buttonSearch: {
    color: "#ffffff",
    background: "#7EBDCE",
    "&:hover": { color: "white", background: "#099F9F" },
  },
}));
